import { getColor, getSpace, mq } from '@stylesheets/tools';
import styled from 'styled-components';

const StyledFilterModal = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${getSpace('xs')};

  ${mq('l')} {
    display: none;
  }

  dialog {
    position: fixed;
    width: 100vh;
    height: 100vh;
    padding: ${getSpace('m')} ${getSpace('s')};
    margin: 0;
    inset: 0;
    border: none;
    z-index: 9999;
    background: ${getColor('white')};
    pointer-events: auto;

    &,
    &::backdrop {
      opacity: 0;
    }

    &:modal {
      width: 100vw;
      max-width: 100vw;
      height: 100vh;
      max-height: 100vh;
    }

    &::backdrop {
      background: transparent;
      cursor: pointer;
      pointer-events: all;
    }
  }

  .filter-modal__content {
    padding-top: ${getSpace('xxl')};
  }
`;

export default StyledFilterModal;
